import React from "react";
import "./Copies.scss";
import ellen from "../../assets/ellen.png";

function Copy3() {
  return (
    <section className="copies">
      <h4 className="copies__title title">DIAGNOSTIC DIFFICULTIES</h4>
      <p className="copies__copy">
        Images are critical to diagnosis in dermatology, and the lack of images
        of darker skin create a hurdle to proper diagnosis and treatment.
        <sup className="copies__copy--sup">2</sup>
      </p>
      <p className="copies__copy">
        This is because eczema may look different on darker skin. “I think
        someone who is a lighter skin tone, so 1 through 3, [will] have more
        erythema that's there, or redness,” says Rice. “So, erythema in someone
        who has more of a darker skin tone like myself may actually project as
        more of a purple than a true pink.”
        <sup className="copies__copy--sup">8</sup> There can be other subtle
        differences across skin tones as well, and a dermatologist unfamiliar
        with skin of color may have more difficulty diagnosing the condition.
        <sup className="copies__copy--sup">2</sup>
      </p>
      <p className="copies__copy">
        When it comes to medical literature and training, the white patient is
        the default, but not because they’re more likely to suffer from eczema.
        In the U.S., Black children are 1.7 times more likely to develop atopic
        dermatitis (AD) than White children.
        <sup className="copies__copy--sup">11</sup> And, AD disproportionally
        affects Black children (19.3%) compared to White (16.1%) and Latino
        children (7.8%).<sup className="copies__copy--sup">11</sup> This makes
        it even more confounding that reference images don’t reflect reality.
        “The representation that we're seeing in popular culture, even within
        our dermatology textbooks, is not matching up with the U.S. population,”
        Dr. Rice says.
        <sup className="copies__copy--sup">8</sup> And this is also true of the
        population worldwide.
      </p>

      <div className="inlinePhoto inlinePhoto--all left">
        <img
          className="inlinePhoto__image"
          src={ellen}
          alt="Portrait of Ellen Buchanan Weiss"
        />
        <p className="inlinePhoto__name inlinePhoto--description">
          Ellen Buchanan Weiss
        </p>
        <p className="inlinePhoto__title inlinePhoto--description">Activist</p>
      </div>

      <p className="copies__copy">
        Ellen Buchanan Weiss’s work to provide diverse medical imagery has
        clearly filled a void, and not just for parents; many of her followers
        are medical professionals. “That's what has been a complete surprise to
        me,” says Ellen Buchanan Weiss. “And also has put some anxiety and
        pressure on me, because you know, I thought that I was going to be sort
        of a casual resource that maybe other moms would look at.”
      </p>
      <p className="copies__copy">
        But Brown Skin Matters has become much more than a casual resource.
        Ellen has no official medical training, and so she would love to
        incorporate an editorial board of dermatologists to vet the images she
        posts as a way to increase the account’s ability to stand alone as a
        reliable resource.
      </p>

      <h4 className="copies__title title">LIVING WITH ECZEMA</h4>
      <p className="copies__copy">
        What people generally understand about eczema is vastly different from
        what it’s like to live with it. It can be isolating, especially for
        people with skin of color. Someone who knows the pain of eczema
        firsthand is Anne Marre Bautista, a research and planning analyst who
        grew up in the Philippines and currently lives in Los Angeles. Anne
        Marre has been living with eczema since infancy and grew up dealing with
        bullying due to her skin condition.
      </p>
      <p className="copies__copy">
        “I remember a specific time when I was younger, I would cry every day,
        coming back from school,” she says. “Every day.”
        <sup className="copies__copy--sup">12</sup>
      </p>
      <p className="copies__copy">
        Anne Marre’s experience highlights the psychological impact eczema can
        have on kids worldwide. Studies have shown that up to 60% of children
        with AD experience sleep disruption because of itching and other
        symptoms. Adult patients also experience a lack of sleep and as a
        result, they report increased fatigue, daytime sleepiness, and insomnia
        <sup className="copies__copy--sup">13,14</sup>—something Anne Marre can
        attest to.
      </p>
      <p className="copies__copy">
        “When I went through one of my biggest outbreaks as an adult, it did
        affect my performance at work because I would lose sleep from it.” She
        recalls scratching her skin so much during the night that she would
        bleed through her sheets.
        <sup className="copies__copy--sup">12</sup>
      </p>
      <p className="copies__copy">
        A study from{" "}
        <a
          className="copies__link italic"
          href="https://www.jacionline.org/article/S0091-6749(06)00450-7/fulltext"
          target="_blank"
          rel="sponsored"
        >
          The Journal of Allergy and Clinical Immunology
        </a>{" "}
        confirms that eczema symptoms negatively impact overall school-work
        performance and productivity.<sup className="copies__copy--sup">15</sup>{" "}
        Productivity isn’t the only thing that suffers. “You’re definitely not
        going to have great mental health if you're not sleeping,” says Dr.
        Rice. “The mental impacts are large, with anxiety and depression being
        something that we always screen for.”
        <sup className="copies__copy--sup">8</sup>
      </p>
    </section>
  );
}

export default Copy3;
